// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon__2Q675","theme":"theme__19o0R"};


//////////////////
// WEBPACK FOOTER
// ./components/icon/style.css
// module id = xAKj
// module chunks = 0